var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinesSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78915 0.679066C3.78233 0.685875 3.77674 1.04588 3.77674 1.47907V2.26666H1.88837H0V2.8527V3.43875H1.88837H3.77674V4.23875V5.03875H4.36279H4.94884V2.8527V0.666656H4.3752C4.05968 0.666656 3.79596 0.672238 3.78915 0.679066ZM6.54884 2.8527V3.43875H11.2744H16V2.8527V2.26666H11.2744H6.54884V2.8527ZM11.0512 7.94107V10.1178H11.6372H12.2233V9.31782V8.51782H14.1116H16V7.94107V7.36433H14.1116H12.2233V6.56433V5.76433H11.6372H11.0512V7.94107ZM0 7.94107V8.51782H4.72558H9.45116V7.94107V7.36433H4.72558H0V7.94107ZM3.77674 11.6434V12.4434H1.88837H0V13.0294V13.6155H1.88837H3.77674V14.4155V15.2155H4.36279H4.94884V13.0294V10.8434H4.36279H3.77674V11.6434ZM6.54884 13.0294V13.6155H11.2744H16V13.0294V12.4434H11.2744H6.54884V13.0294Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesSettings);
export default __webpack_public_path__ + "static/media/icon--lines-settings.5059c4a60cf5f03bd8506dd14da408e5.svg";
export { ForwardRef as ReactComponent };